var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeySvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2081_38461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19735 12.2935C7.19735 11.0003 6.12496 9.95193 4.80213 9.95193C3.47929 9.95193 2.4069 11.0003 2.4069 12.2935C2.4069 13.5868 3.47929 14.6351 4.80213 14.6351C6.12496 14.6351 7.19735 13.5868 7.19735 12.2935ZM9.59253 12.2935C9.59253 14.88 7.4478 16.9767 4.80213 16.9767C2.15645 16.9767 0.0117188 14.88 0.0117188 12.2935C0.0117188 9.70708 2.15645 7.61035 4.80213 7.61035C7.4478 7.61035 9.59253 9.70708 9.59253 12.2935Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8368 0.342919C15.3045 -0.114306 16.0627 -0.114306 16.5304 0.342919C16.9981 0.800144 16.9981 1.54146 16.5304 1.99868L8.04445 10.2947C7.57675 10.752 6.81846 10.752 6.35077 10.2947C5.88308 9.83751 5.88308 9.09619 6.35077 8.63897L14.8368 0.342919Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.632 2.09878C15.0997 1.64155 15.858 1.64155 16.3257 2.09878L17.6261 3.37003C18.0937 3.82725 18.0937 4.56854 17.6261 5.02576C17.1584 5.48299 16.4001 5.48302 15.9324 5.0258L14.632 3.75454C14.1643 3.29732 14.1643 2.556 14.632 2.09878Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6379 5.02651C12.1056 4.56929 12.8639 4.56929 13.3316 5.02651L14.6319 6.29777C15.0996 6.75499 15.0996 7.49631 14.6319 7.95353C14.1642 8.41076 13.4059 8.41076 12.9382 7.95353L11.6379 6.68228C11.1702 6.22505 11.1702 5.48374 11.6379 5.02651Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2081_38461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeySvgrepoCom1);
export default __webpack_public_path__ + "static/media/key-svgrepo-com 1.fbbc887ba23a07dbd0d32c7f74ff644e.svg";
export { ForwardRef as ReactComponent };